define('ANSI/Utility/EllipsisMaker',['jquery', 'eventManager', 'ANSI/Utility/SitecoreUtils'], function ($, eventManager, sitecoreUtils) {
    'use-strict';
    function EllipsisMaker() {}

    EllipsisMaker.prototype = {
        init: function () {
            // call updateItems with (number of lines , element)
            eventManager.subscribe('ModulesLoadedEvent', function () {
                if ($('.pagination-buttons').length > 0) {
                    EllipsisMaker.prototype.updateItems(2, $('.overlay h4'));
                }
            });
        },
        getLineHeight: function (el) {
            var lineHeight = window.getComputedStyle(el)['line-height'];
            return lineHeight === 'normal' ? 1.16 * parseFloat(window.getComputedStyle(element)['font-size']) : parseFloat(lineHeight);
        },
        updateItems: function (lines, el) {
            var el = $(el);
            $(el).each(function (i, item) {
                var $item = $(item);
                $item.attr('data-text-content', item.textContent);
                $item.attr('data-line-height', EllipsisMaker.prototype.getLineHeight(item));
                EllipsisMaker.prototype.doEllipsis(lines, item);
            });
        },
        doEllipsis: function (lines, el) {
            var $element = $(el),
                inner = document.createElement('SPAN'),
                text = $element.attr('data-text-content'),
                lineHeight = $element.attr('data-line-height'),
                maxHeight = lines * lineHeight,
                textParts = text.split(' ');

            if (!text) return;

            el.innerHTML = '';
            el.style.height = 'auto';
            el.style.maxHeight = maxHeight + 'px';
            el.appendChild(inner);
            inner.innerHTML = text;
            inner.style.display = 'block';

            if (inner.clientHeight < maxHeight) return;

            while (inner.clientHeight > maxHeight) {
                textParts.pop();
                inner.innerHTML = textParts.join(' ') + '...';
            }
        }
    };
    if (!sitecoreUtils.prototype.isEditing()) Promise.resolve().then(EllipsisMaker.prototype.init);
});

